define('commons/coverage-conf-multi-slider',['jquery', 'commons/simple-multi-slider', 'utils/colors', 'jquery.ui'], function($, SimpleMultiSlider, colorUtils) {
    var CoverageConfMultiSlider = function(slideId, resultClass, targetStepId, targetPrefix, slideSensiClass, colorSteps, colors, sensi, minDb, maxDb) {
        this.targetStep = $(targetStepId);
        this.resultClass = resultClass;

        this.rawValue = function(sliderValue) {
            var raw;
            if (sliderValue <= 20) {
                raw = sliderValue * 10;
            } else if (sliderValue <= 26) {
                raw = 200 + (sliderValue - 20) * 50;
            } else if (sliderValue <= 41) {
                raw = 500 + (sliderValue - 26) * 100;
            } else if (sliderValue <= 47) {
                raw = 2000 + (sliderValue - 41) * 500;
            } else if (sliderValue <= 62) {
                raw = 5000 + (sliderValue - 47) * 1000;
            } else if (sliderValue <= 68) {
                raw = 20000 + (sliderValue - 62) * 5000;
            } else if (sliderValue <= 79) {
                raw = 50000 + (sliderValue - 68) * 10000;
            }
            return raw;
        };

        var sliderValue = function (rawValue) {
            var slider;
            if (rawValue <= 200) {
                slider = rawValue / 10;
            } else if (rawValue <= 500) {
                slider = 20 + (rawValue - 200) / 50;
            } else if (rawValue <= 2000) {
                slider = 26 + (rawValue - 500) / 100;
            } else if (rawValue <= 5000) {
                slider = 41 + (rawValue - 2000) / 500;
            } else if (rawValue <= 20000) {
                slider = 47 + (rawValue - 5000) / 1000;
            } else if (rawValue <= 50000) {
                slider = 62 + (rawValue - 20000) / 5000;
            } else if (rawValue <= 200000) {
                slider = 68 + (rawValue - 50000) / 10000;
            }
            return slider;
        };

        var values = [sliderValue(colorSteps[0]), sliderValue(colorSteps[1]), sliderValue(colorSteps[2]), sliderValue(colorSteps[3]), sliderValue(colorSteps[4]), sliderValue(colorSteps[5])];

        var color = function(value) {
            return colorUtils.sensiToRGB(value, 0, maxDb - minDb);
        };

        var doUpdateTarget = function(event, ui) {
            var curValue;
            if (ui && typeof ui.value !== "undefined") {
                curValue = ui.value;
            } else {
                var curStep = $(event.target).data("step");
                var curLevel = $(event.target).data("level");
                curValue = sensi[(3 * curStep) + curLevel];
            }

            $(event.target).css('background', color(curValue));
            
            var step = $(event.target).data("step");
            var level = $(event.target).data("level");
            var nextValue;
            if (ui && typeof ui.value !== "undefined") {
                if (step < 6) {
                    nextValue = $("#slide_" + (step + 1) + "_" +  level).slider("value");
                    if (curValue > nextValue) {
                        $("#slide_" + (step + 1) + "_" +  level).slider( "value", curValue );
                    }
                }
                if (step > 0) {
                    nextValue = $("#slide_" + (step - 1) + "_" +  level).slider("value");
                    if (curValue < nextValue) {
                        $("#slide_" + (step - 1) + "_" +  level).slider( "value", curValue );
                    }
                }
                if (level > 0) {
                    nextValue = $("#slide_" + step + "_" +  (level - 1)).slider("value");
                    if (curValue > nextValue) {
                        $("#slide_" + step + "_" + (level - 1)).slider( "value", curValue );
                    }
                }
                if (level < 2) {
                    nextValue = $("#slide_" + step + "_" +  (level + 1)).slider("value");
                    if (curValue < nextValue) {
                        $("#slide_" + step + "_" + (level + 1)).slider( "value", curValue );
                    }
                }
            }
    
            $(targetPrefix + step + "_" + level).val(curValue);
    
            var target = event.target.childNodes[0];
            if (curValue == -1) {
                curValue = "Na";
            }
            var tooltip = '<div class="tooltip"><div class="tooltip-inner">' + curValue + '</div><div class="tooltip-arrow"></div></div>';
            $(target).html(tooltip);
        };
        var i = 0;
        $(slideSensiClass).each(function (j, elem)  {
            $( this ).empty().slider({
                min: -1,
                max: maxDb - minDb,
                value: sensi[i],
                create: doUpdateTarget,
                slide: doUpdateTarget,
                change: doUpdateTarget
            });
            i++;
        });

        SimpleMultiSlider.call(this, slideId, values, colors, 0, 79, {rawValue : this.rawValue});
    };

    //Inherit from SimpleMultiSlider
    for ( var element in SimpleMultiSlider.prototype) {
     CoverageConfMultiSlider.prototype[element] = SimpleMultiSlider.prototype[element];
    }

    /**
     * @OVERRIDE
     */
    CoverageConfMultiSlider.prototype.doUpdate = function(event, ui) {
        SimpleMultiSlider.prototype.doUpdate.call(this, event,ui);

        var here = this;
        this.targetStep.each(function(i, elem) {
            if (i === 0) {
                $(elem).text("0-" + here.rawValue(here.values[i]));
            } else if (i == 6) {
                $(elem).text(here.rawValue(here.values[i-1]) + "-160000");
            } else {
                $(elem).text(here.rawValue(here.values[i-1]) + "-" + here.rawValue(here.values[i]));
            }
        });
        $(this.resultClass).each(function( i ) {
            $(this).val(here.rawValue(here.values[i]));
        });
    };

    return CoverageConfMultiSlider;
});

